export const MAX_RANK = 50;
export const API_BASE_URL = 'https://proxy.ecosia.org/weather';
export const LOCATION_URL = `${API_BASE_URL}/location`;
export const CURRENT_CONDITIONS_URL = `${API_BASE_URL}/current-conditions`;
export const PARTNER_CODE = 'web_ecosia_cityent_adc';
